class Node {
  constructor ({ tree, payload }) {
    Object.assign(
      this,
      {
        tree,
        // Own
        parent: undefined,
        children: [],
        opened: true
      },
      payload
    )
  }

  clone (tree) {
    return new Node({ tree, payload: Object.assign(this, { parent: undefined, children: [], opened: true }) })
  }

  mapParentAndChildren () {
    if (this.parentId) {
      this.parent = this.tree.getNode(this.parentId)
    }
    this.parent && this.parent.children.push(this)
  }

  get ancestorsAndThisString () {
    return this.fullRouteStrings().join(' > ')
  }

  treeAncestors () {
    return this.parent ? [...this.parent.treeAncestors(), this] : [this]
  }

  fullRouteStrings () {
    return this.treeAncestors().map(node => node.name)
  }

  hasChildren () {
    return !!this.children.length
  }

  getSelfAndAllChildren () {
    return [this, ...this.getAllChildren()]
  }

  getAllChildren () {
    return [].concat(...this.children.map(node => node.getSelfAndAllChildren()))
  }
}

export default class TreeModel {
  constructor ({ payloads }) {
    this.nodes = []
    // Construct nodes
    payloads.forEach(payload =>
      this.nodes.push(new Node({ tree: this, payload })))
    // Map nodes
    this.nodes.forEach(node => node.mapParentAndChildren())
  }

  clone () {
    return new TreeModel({ payloads: this.nodes.map(node => node.clone()) })
  }

  roots () {
    return this.nodes.filter(node => !node.parent)
  }

  getNode (id) {
    return this.nodes
      .find(node => String(node.id) === String(id))
  }
}
